let tokens = [
    { edition: 1, nickname: "Shaggy" },
    { edition: 2, nickname: "Britney 3000" },
    { edition: 18, nickname: "api42" },
    { edition: 19, nickname: "Loverboy" },
    { edition: 21, nickname: "HappyDany" },
    { edition: 23, nickname: "Scar Face" },
    { edition: 24, nickname: "Peter Parker" },
    { edition: 25, nickname: "Shades" },
    { edition: 26, nickname: "Sinister Steve" },
    { edition: 28, nickname: "SpaceFace" },
]

export function getNickname(tokenEdition) {

    let nickname = "Anonymous";

    tokens.forEach(token => {
        if (token.edition === tokenEdition) {
            nickname = token.nickname;
        }
    })

    return nickname;
}